<div class="bg-elevated flex h-full flex-none flex-col overscroll-none rounded-md">
  @if (list()) {
    <div
      class="flex-none border-b-8 p-3"
      [style.border-color]="
        list().aggregatorId | colorOfIndex: { typeOfResult: 'hex', color: list().color }
      ">
      <div class="flex flex-row-reverse">
        <button
          (click)="emitHide()"
          app-button
          class="text-text-primary hover:bg-interactive hover:text-text-primary focus:bg-interactive focus:text-text-primary block cursor-pointer px-2 py-1 text-sm leading-5 whitespace-nowrap focus:outline-none"
          size="small">
          <i [class]="ICONS.eyeSlash"></i>
        </button>
      </div>

      <div class="text-text-primary flex justify-between pr-4 text-lg font-semibold">
        <div class="w-full break-words">{{ list().name }}</div>
        <div class="text-text-tertiary text-sm">
          {{ list().items.length }} {{ list().itemsName | lowercase }}
        </div>
      </div>
    </div>

    <ul
      #listElement
      (scroll)="onScrollList($event)"
      (cdkDropListDropped)="drop($event)"
      [cdkDropListDisabled]="!enableEdit()"
      [cdkDropListData]="{
        aggregatorId: list().aggregatorId,
        elemsIds: list().appElemIds
      }"
      [style.cursor]="enableEdit() ? 'move' : 'default'"
      cdkDropList
      class="metro-style flex-1">
      @for (item of list().items; track trackListItem($index, item)) {
        <li
          #listItemElement
          cdkDrag
          class="metro-element before:border-default before:bg-surface after:border-default relative mb-2"
          [class.item-done]="item.taskDone">
          <div class="h-24" *cdkDragPlaceholder></div>
          <div
            class="w-64 p-5 font-medium break-words text-zinc-700 shadow-md shadow-zinc-600 dark:text-zinc-300 dark:shadow-zinc-400"
            *cdkDragPreview>
            {{ item.name }}
          </div>

          <div class="w-full px-3">
            <div class="flex justify-between pb-2">
              <div class="text-text-primary font-medium break-words">
                {{ item.name }}
              </div>
            </div>

            @if (!item.hasBeenMoved) {
              <table class="table-fixed text-sm">
                <tbody>
                  @for (label of filterLevel0Labels(item.labels); track label.label) {
                    <tr>
                      <td class="text-text-tertiary pb-2 align-top leading-4 font-light">
                        {{ label.label }}
                      </td>
                      <td
                        class="text-text-tertiary w-3 pb-2 text-center align-top leading-4 font-light">
                        :
                      </td>
                      <td class="text-text-secondary pb-2 align-top leading-4">
                        <span class="hover:bg-interactive break-words">
                          {{ label.value }}
                        </span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>

              @if (hasDetails(item.labels)) {
                <div
                  class="accordion-body"
                  [class.accordion-expanded]="isShowingDetails(item)">
                  <div>
                    @if (!item.hasBeenMoved) {
                      <table class="table-fixed text-sm">
                        <tbody>
                          @for (
                            label of filterOtherLabels(item.labels);
                            track label.label
                          ) {
                            <tr>
                              <td
                                class="text-text-tertiary pb-2 align-top leading-4 font-light">
                                {{ label.label }}
                              </td>
                              <td
                                class="text-text-tertiary w-3 pb-2 text-center align-top leading-4 font-light">
                                :
                              </td>
                              <td class="text-text-secondary pb-2 align-top leading-4">
                                <span class="hover:bg-interactive break-words">
                                  {{ label.value }}
                                </span>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                  </div>
                </div>
              }
            } @else {
              <div class="text-text-tertiary py-2 text-sm font-light">
                {{ 'visualization.list.recompute_solution' | translate }}
              </div>
            }

            <div class="flex flex-row">
              @if (enableMarkTaskAsDone()) {
                <button
                  type="button"
                  (click)="toggleTaskDone(item)"
                  [title]="'visualization.list.mark_done' | translate"
                  [class]="getMarkerTaskClasses(item)">
                  <i [class]="ICONS.checkCircle"></i>
                </button>
              }

              <!-- Item Location button link -->
            </div>
            <div class="relative mt-7 text-center">
              <hr class="text-zinc-200 dark:text-zinc-800" />
              @if (hasDetails(item.labels)) {
                <button
                  (click)="toggleShowDetails(item)"
                  class="absolute top-1/2 left-1/2 mr-2 flex size-10 -translate-x-1/2 -translate-y-1/2 transform cursor-pointer justify-center rounded-full bg-zinc-200 p-3 hover:bg-zinc-300 dark:bg-zinc-800 hover:dark:bg-zinc-700">
                  <i
                    [class]="[
                      'ph-bold',
                      isShowingDetails(item) ? 'ph-caret-up' : 'ph-caret-down'
                    ]"></i>
                </button>
              }
            </div>
          </div>
        </li>
      }
    </ul>
    <div class="flex flex-none flex-row-reverse p-3"></div>
  } @else {
    <div>
      <span>{{ 'visualization.list.not_available' | translate }}</span>
    </div>
  }
</div>
